import _ from "lodash";
import React from "react";
import { Popover } from "@toddle-edu/react-tiny-popover";
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";

import FieldComponent from "UnitPlans/components/IBcomponents/FieldComponent";
import { getPopupDataForSubFields } from "Assessments/modules/Utils";

import classes from "./PopupForSubFields.scss";

const popupContainerStyle = {
  left: "-120px",
  zIndex: 1500,
};

const popupStyle = {
  height: "360px",
  width: "600px",
};

const PopupForSubFields = props => {
  const {
    subFields,
    childrenRef,
    closePopover,
    optionId,
    unitPlanFieldList,
    fieldKey,
    unitPlanFields,
    dataField,
    emptyPopupSubText,
  } = props;

  const renderPopover = () => {
    const { popupData } = getPopupDataForSubFields({
      unitPlanFieldList,
      fieldKey,
      unitPlanFields,
      dataField,
      subFields,
    });

    const popDataForCurrentOption = popupData[optionId];

    const updatedSubFields = _.filter(
      subFields,
      ({ key }) =>
        !_.isEmpty(_.get(popDataForCurrentOption, `${key}.viewModeValues`, {}))
    );

    return (
      <div style={popupStyle} className={classes.popupContainer}>
        {_.map(updatedSubFields, (fieldObj, index) => {
          return (
            <div className={classes.fieldContainer}>
              <div className={classes.fieldHeaderContainer}>
                <div className="text-label-2">
                  {_.get(fieldObj, "config.label", null)}
                </div>
                {index === 0 && (
                  <IconButton
                    variant="plain"
                    icon={<CloseOutlined />}
                    size="x-small"
                    onClick={closePopover}
                  />
                )}
              </div>
              <FieldComponent
                value={_.get(
                  popDataForCurrentOption,
                  `${fieldObj.key}.viewModeValues`,
                  {}
                )}
                mode="view"
                key={fieldObj.key}
                type={fieldObj.viewType}
                fieldTypeConfig={_.get(fieldObj, "config.fieldTypeConfig", {})}
              />
            </div>
          );
        })}
        {_.isEmpty(updatedSubFields) && (
          <div className={classes.emptyPopupContainer}>
            <div className={classes.emptyPopupHeader}>
              <IconButton
                variant="plain"
                icon={<CloseOutlined />}
                size="x-small"
                onClick={closePopover}
              />
            </div>
            {emptyPopupSubText}
          </div>
        )}
      </div>
    );
  };

  return (
    <Popover
      isOpen
      align="start"
      positions={["bottom", "top"]}
      reposition
      onClickOutside={closePopover}
      containerStyle={popupContainerStyle}
      content={renderPopover}
      isChildrenRefPassed
      childrenRef={{ current: childrenRef }}
    />
  );
};

export default PopupForSubFields;
